import { Calendar, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Team } from "@/types";

interface TeamCardProps {
  team: Team;
  onClick: () => void;
}

export default function TeamCard({ team, onClick }: TeamCardProps) {
  const { t, i18n } = useTranslation("pages");
  const memberCount = team.memberCount ?? team.members?.length ?? 0;

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-lg border border-secondary-200 px-4 py-3 sm:px-5 sm:py-3.5 cursor-pointer hover:border-secondary-300 transition-colors"
    >
      {/* Row 1: Title */}
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-base font-semibold text-secondary-900 truncate">
          {team.name}
        </h3>
      </div>

      {/* Row 2: Inline metadata */}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1.5 text-sm text-secondary-500">
        <span className="flex items-center gap-1">
          <Users className="h-3.5 w-3.5 text-secondary-400 flex-shrink-0" />
          {t("teams.members", { count: memberCount })}
        </span>
        <span className="flex items-center gap-1">
          <Calendar className="h-3.5 w-3.5 text-secondary-400 flex-shrink-0" />
          {t("teams.created", {
            date: new Date(team.createdAt).toLocaleDateString(i18n.language),
          })}
        </span>
        {team.description && (
          <>
            <span className="text-secondary-400">·</span>
            <span className="truncate max-w-xs">{team.description}</span>
          </>
        )}
      </div>
    </div>
  );
}
